/* eslint import/prefer-default-export: 0 */

export const formattedNumber = number => (
    number.toLocaleString('en', { maximumFractionDigits: 0 })
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
);

export const formattedDollar = number => (
    number.toLocaleString('en', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
);

export const formattedkW = number => (
    number.toLocaleString('en', { maximumFractionDigits: 3, minimumFractionDigits: 3 })
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
);



// WEBPACK FOOTER //
// ./src/utils/formatterHelpers/index.js